export default __webpack_public_path__ + "static/sides-89ed02a0f8ef86f697f5b11701b2b3c7.png";